const isInvalidTimeFormat = (value: string) => {
  const [hh, mm] = value.split(':').map(Number);

  return Number.isNaN(hh) || Number.isNaN(mm) || hh < 0 || hh >= 24 || mm < 0 || mm >= 60;
};

export {isInvalidTimeFormat};
